import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { passwordStrengthValidator } from '../../validators/passwords-strength.validator';
import { passwordsMatchValidator } from '../../validators/password-match.validator';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import Messages from '../../enums/messages.enum';
import { TokenService } from 'src/app/core/auth/services/token.service';
@Component({
    selector: 'app-change-password-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatInputModule,
        MatIconModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule],
    templateUrl: './modal-change-password.component.html',
    styleUrls: ['./modal-change-password.component.scss'],
})
export class ChangePasswordDialogComponent implements OnInit {
    constructor(
        private authService: AuthService,
        private tokenService: TokenService,
        private notificationService: NotificationService,
        private translate: TranslateService,
        public dialogRef: MatDialogRef<ChangePasswordDialogComponent>) {
    }

    ngOnInit() {
        this.form.valueChanges.subscribe(values => {
            const cleanedValues: any = {};

            for (const key in values) {
                if (values.hasOwnProperty(key)) {
                    let value = values[key]?.trim() ?? '';

                    value = value.replace(/\s+/g, '');
                    if (value !== values[key]) {
                        cleanedValues[key] = value;
                    }
                }
            }

            if (Object.keys(cleanedValues).length > 0) {
                this.form.patchValue(cleanedValues, { emitEvent: false });
            }
        });
    }

    form: FormGroup = new FormGroup({
        currentPassword: new FormControl('', [Validators.required]),
        newPassword: new FormControl('', [Validators.required, passwordStrengthValidator]),
        confirmPassword: new FormControl('', [Validators.required])
    }, {
        validators: passwordsMatchValidator()
    }
    );


    hideCurrentPassword = true;
    hideNewPassword = true;
    hideConfirmPassword = true;
    countdown = 0;
    isDisabled = false;
    private timer: any;


    get currentPassword() { return this.form.get('currentPassword'); }
    get newPassword() { return this.form.get('newPassword'); }
    get confirmPassword() { return this.form.get('confirmPassword'); }


    get passwordErrors() {
        return this.form.get('newPassword')?.errors || {};
    }

    get confirmPasswordTouched() {
        return this.form.get('confirmPassword')?.touched;
    }

    get passwordTouched() {
        return this.form.get('newPassword')?.touched;
    }

    get passwordsMismatch() {
        return this.form.hasError('passwordsMismatch') && this.form.get('confirmPassword')?.touched;
    }

    public updatePassword() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            console.error('Form is invalid');
            return;
        }

        var updatePassword = {
            currentPassword: this.form.value.currentPassword.trim(),
            newPassword: this.form.value.newPassword,
            confirmPassword: this.form.value.confirmPassword
        }

        this.dialogRef.close(updatePassword);

    }


    reset(): void {
        if (this.isDisabled) return;
        this.isDisabled = true;
        this.countdown = 60;
        this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
                clearInterval(this.timer);
                this.isDisabled = false;
            }
        }, 1000);

        const login = { login: this.tokenService.getToken(this.tokenService.EMAIL) }
        if (login) {
            this.authService.resetPassword(login).subscribe((result: any) => {
                this.notificationService.messageSuccess(this.translate.instant(Messages.LOGIN_SUCCESS_RESET_PASSWORD, { name: result }), undefined, undefined, 'bottom');
            }, (error: any) => {
                this.notificationService.messageError(error.error);
            });
        } else {
            this.notificationService.messageError("Não foi possível recuperar o e-mail do usuário.");
        }
    }
} 